import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    this.show()
  }

  show() {
    // Sync the CSS progress bar animation with the dismiss duration
    this.element.style.setProperty('--notification-duration', `${this.durationValue}ms`)

    // Slide in
    setTimeout(() => {
      this.element.classList.add('notification-visible')
    }, 100)

    setTimeout(() => {
      this.hide()
    }, this.durationValue)
  }

  hide() {
    this.element.classList.add('notification-hiding')
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Allow manual dismiss by clicking
  dismiss() {
    this.hide()
  }
}
